import { render, staticRenderFns } from "./specialGoodsEdit.vue?vue&type=template&id=441aa24a&"
import script from "./specialGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./specialGoodsEdit.vue?vue&type=script&lang=js&"
import style0 from "./specialGoodsEdit.vue?vue&type=style&index=0&id=441aa24a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports